import ViewAllStdEquipmentData from "./ViewAllStdEquipmentData";

export default ViewAllStdEquipmentData;
